import { RefObject } from 'react';

// Добавляет класс 'active' слайду и всем его копиям
export const activateSlidesAndCopies = (
  slideIndex: number,
  sliderElem: RefObject<HTMLDivElement>,
  slidesCount: number
) => {
  // react-slick формирует три группы слайдов (отображаются друг за другом):
  //  1) левые копии - имеют отрицательный индекс (от -slidesCount до -1)
  //  2) оригиналы - имеют индекс в соответствии с порядком
  //  3) "правые" копии - имеют индекс равный текущему слайду плюс длина всех
  //     оригинальных слайдов (от slideIndex + slidesCount до slidesCount * 2)

  // селектор оригинального слайда
  const originalSlideSelector = `.slick-slide[data-index="${slideIndex}"]`;

  // селектор для копии слайда "слева"
  const prevSlideCloneSelector = `.slick-slide[data-index="${
    slideIndex - slidesCount
  }"]`;

  // селектор для копии слайда "справа"
  const nextSlideCloneSelector = `.slick-slide[data-index="${
    slideIndex + slidesCount
  }"]`;

  sliderElem?.current
    ?.querySelectorAll(
      `${prevSlideCloneSelector}, ${originalSlideSelector}, ${nextSlideCloneSelector}`
    )
    .forEach((slideElem) => {
      // Для корректной логики переключения мы добавляем текущему слайду и его копиям
      // класс 'active'
      slideElem.classList.add('slick-active');
    });
};

// Удаляем класс 'active' у всех слайдов, кроме того, чей индекс был передан
// (при этом 'active' удаляется у всех копий слайда с переданным индексом)
export const deactivateSlidesExcept = (
  slideIndex: number,
  sliderElem: RefObject<HTMLDivElement>
) => {
  sliderElem?.current
    // Селектор для выбора всех слайдов, которые не содержат атрибут
    // с переданным индексом и не являются копиями
    ?.querySelectorAll(`.slick-slide:not([data-index="${slideIndex}"])`)
    .forEach((slideElem) => {
      slideElem.classList.remove('slick-active');
    });
};

export type TCoverBackgroundSettings = {
  url: string;
  type?: 'image' | 'video';
  poster?: string;
};

export type TCoverBackgroundTarget = {
  imageUrl: string;
  imageMobileUrl?: string;
  videoUrl?: string;
};

export const getCoverBackgroundSettings = (
  target: TCoverBackgroundTarget,
  isMobile?: boolean
): TCoverBackgroundSettings => {
  const { videoUrl, imageUrl, imageMobileUrl } = target;

  const settings: TCoverBackgroundSettings = {
    url: '',
    type: 'image',
  };

  if (isMobile) {
    settings.url = videoUrl || imageMobileUrl || imageUrl || '';
  } else {
    settings.url = videoUrl || imageUrl || '';
  }

  if (settings.url === videoUrl) {
    settings.type = 'video';
    settings.poster = isMobile
      ? imageMobileUrl || imageUrl || ''
      : imageUrl || '';
  }

  return settings;
};

export const getProxyPosterUrl = () => {};
